import { Alert, AlertDescription, AlertTitle } from 'app/components/ui/alert';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FreeEventTicketType } from './useFreeEventData';

import { Button } from 'app/components/ui/button';
import { Info } from 'lucide-react';

interface FreeEventRegistrationTicketTypesProps {
  ticketTypes: FreeEventTicketType[];
  selectedTicketType: number;
  setSelectedTicketType: (index: number) => void;
}

const FreeEventRegistrationTicketTypes: React.FC<
  FreeEventRegistrationTicketTypesProps
> = ({ ticketTypes, selectedTicketType, setSelectedTicketType }) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="title-sm mb-4">
        {t('freeEventRegistrationPage.registrationOptions')}
      </p>
      <div className="flex flex-wrap gap-[8px] mb-[16px]">
        {ticketTypes.map((ticketType, index) => (
          <Button
            key={ticketType.id}
            onClick={() => setSelectedTicketType(index)}
            variant={selectedTicketType === index ? 'default' : 'outline'}
          >
            {ticketType.name}
          </Button>
        ))}
      </div>
      {selectedTicketType >= 0 &&
      ticketTypes[selectedTicketType].isWhitelisted ? (
        <Alert className="bg-neutral-20 mb-4">
          <Info size={16} />
          <AlertTitle>
            {t('freeEventRegistrationPage.whitelistedTicketAlertTitle')}
          </AlertTitle>
          <AlertDescription>
            {t('freeEventRegistrationPage.whitelistedTicketAlertContent')}
          </AlertDescription>
        </Alert>
      ) : null}
    </div>
  );
};

export default FreeEventRegistrationTicketTypes;
